import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import {
	CardSelectComponent,
	FormGroupComponent,
	InputComponent,
	ItemComponent,
	ListDetailComponent,
	SwitchComponent,
	TextareaComponent,
	TileComponent,
	ToggleComponent,
} from '@tecalisdev/infinity';
import { OPERATION_TYPE } from '../../../../operations/models/operations.models';
import { WorkflowFormOperationPanelBase } from './workflow-form-operation-panel.base';
import { WorkflowFormAdvancedCollapseComponent } from '../workflow-form-advanced-collapse.component';

/**
 * Panel UI de ATTORNEY_POWERS en el editor (NIF-530).
 *
 * Abrir cuando: cambias método auto/manual, fallback o tutorial.
 * Bindings relativos a `group`; lógica de payload en util/host.
 */
@Component({
	selector: 'app-workflow-form-attorney-powers-panel',
	imports: [
		WorkflowFormAdvancedCollapseComponent,
		ReactiveFormsModule,
		TranslatePipe,
		TileComponent,
		ItemComponent,
		FormGroupComponent,
		ToggleComponent,
		TextareaComponent,
		ListDetailComponent,
		CardSelectComponent,
		SwitchComponent,
		InputComponent,
	],
	templateUrl: './workflow-form-attorney-powers-panel.component.html',
})
export class WorkflowFormAttorneyPowersPanelComponent
	extends WorkflowFormOperationPanelBase
	implements OnInit
{
	protected readonly operationType = OPERATION_TYPE.ATTORNEY_POWERS;
	private readonly destroyRef = inject(DestroyRef);

	public get mode(): string {
		return this.readSelectId('mode');
	}

	public get fallback(): string {
		return this.readSelectId('fallback');
	}

	public get fallbackValidation(): string {
		return this.readSelectId('fallback_validation');
	}

	public setMode(next: 'auto' | 'manual', selected: boolean): void {
		this.patchControl('mode', selected ? next : '');
	}

	public ngOnInit(): void {
		this.group
			.get('total_tries')
			?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((value) => this.clampTotalTries(value));
	}

	public clampTotalTries(value: unknown): void {
		if (value === null || value === undefined || value === '') {
			return;
		}
		const numericValue = Number(value);
		if (Number.isNaN(numericValue)) {
			return;
		}
		const clampedValue = Math.min(4, Math.max(1, numericValue));
		if (clampedValue !== numericValue) {
			this.patchControl('total_tries', clampedValue);
		}
	}
}
